enum IdentityUploaderStatuses {
  'empty',
  'uploading',
  'error',
}
export default IdentityUploaderStatuses;
